import React from "react";
import { useNavigate } from "react-router-dom";

import {
  ActionsWrapper,
  AmountWrapper,
  Container,
  Content,
  ContentText,
  IconWrapper,
  PriceTransaction,
  TextWrapper,
  TransactionTime,
} from "./transaction.styled";

import { ReactComponent as RightArrow } from "@assets/images/chevrons/chevron-right.svg";
import { ReactComponent as InTransaction } from "@assets/images/transaction/in.svg";
import { ReactComponent as OutTransaction } from "@assets/images/logo/logos.svg";

const Transaction = ({
  status,
  amount,
  currency,
  date,
  id,
  title,
}: {
  status: "in" | "out";
  amount: number;
  currency: string;
  date: string;
  id: string;
  title: string;
}) => {
  const navigate = useNavigate();

  var inputDate = new Date(date);
  var day = inputDate.getUTCDate();
  var month = inputDate.getUTCMonth() + 1;
  var year = inputDate.getUTCFullYear() % 100;
  var formattedDate = `${day.toString().padStart(2, "0")}/${month
    .toString()
    .padStart(2, "0")}/${year.toString().padStart(2, "0")}`;

  return (
    <Container onClick={() => navigate(`/transaction/${id}`)}>
      <IconWrapper>
        <OutTransaction  />
      </IconWrapper>
      <Content>
        <TextWrapper>
          <ContentText>{title}</ContentText>
          <TransactionTime>{formattedDate}</TransactionTime>
        </TextWrapper>
        <ActionsWrapper>
          <AmountWrapper>
            <PriceTransaction>{`${amount} ${currency.toUpperCase()}`}</PriceTransaction>
            <RightArrow />
          </AmountWrapper>
        </ActionsWrapper>
      </Content>
    </Container>
  );
};

export default Transaction;
